import { SpecialExpense } from '../models/special-expense';
import { PagedStoreBase } from './PagedStoreBase';

export default class SpecialExpenseStore extends PagedStoreBase<SpecialExpense> {
  constructor() {
    super('SpecialExpenses');
  }

  protected sortItems = (items: SpecialExpense[]) => {
    return items.sort(({ expenseDate: ad }, { expenseDate: bd }) => {
      const a = ad.getTime();
      const b = bd.getTime();
      return b > a ? 1 : b < a ? -1 : 0;
    });
  };

  setItem = (item: SpecialExpense) => {
    item.expenseDate = new Date(item.expenseDate);
    this.itemRegistry.set(item.id, item);
  };
}
